$(function(){
  $('.button-primary').addClass('no-active');
  $('.notice').prop('checked', false);
  $('.cart-notice-check label').click(function () {
    var flg = 0;
    $('.notice').each(function () {
      if ($(this).prop("checked") == false) {
        flg = 1;
      }
    });
    if(flg == 0) {
      $('.button-primary').removeClass('no-active');
      $('.button-primary').prop('disabled', false);
    } else {
      $('.button-primary').addClass('no-active');
      $('.button-primary').prop('disabled', true);
    }
  });

  if($('.notice').length == 0) {
      $('.button-primary').removeClass('no-active');
      $('.button-primary').prop('disabled', false);
  }

  if(document.cookie.indexOf('country=JP') == -1) {
    $.getJSON('https://ipapi.co/json/', function(data) {
//    $.getJSON('https://kitutuki.co.jp/checkIP.php', function(data) {
      var country = data.country;
      document.cookie = 'country=' + country;
      if(country != 'JP' && window.location.pathname != '/pages/sorry') {
        window.location.replace('/pages/sorry');
      }
    })
  };

  if(document.cookie.indexOf('country=JP') == -1 && window.location.pathname != '/pages/sorry') {
//      window.location.replace('/pages/sorry');
  };

  var brand_site = 'https://kitutuki.co.jp/';
  var not_show_dir = ['collections', 'products'];
  var arr = location.pathname.split('/');
//  if(arr[1] == '') window.location.href = brand_site;
  $.each(not_show_dir, function(i, value) {
    if(arr[1] == value) {
//      window.location.href = brand_site;
    }
  });


});